export default __webpack_public_path__ + "a3dca048b1fd70d07b2b3653e241bfc5.png";